document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ft-products-swiper').forEach((slider) => {

    slider.classList.add('swiper-loading');

    new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      speed: 800,

      on: {
        init: function () {
          slider.classList.remove('swiper-loading');
        }
      },

      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      },

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },

      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1620: {
          slidesPerView: 5,
          spaceBetween: 20
        }
      }
    });

  });
});